<template>
  <v-dialog v-model="dialog" persistent max-width="390">
    <v-card>
      <v-card-title class="indigo white--text headline">
        <span class="title font-weight-light">{{ $t('error_tile') }}</span>
      </v-card-title>

      <v-card-text>
        <p>
          <strong>{{ $t('ecode') }}:</strong>
          {{ code }}
        </p>
        <p>
          <strong>{{ $t('message') }}:</strong>
          {{ message }}
        </p>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="primary" @click="dialog = false">{{ $t('close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      code: null,
      message: null,
      exception: ''
    }
  },
  methods: {
    show(data) {
      this.code = data.Code
      this.message = data.Message
      this.exception =
        typeof data.Exception !== 'undefined' ? data.Exception : ''
      this.dialog = true
    }
  },
  watch: {
    dialog(val) {
      if (!val) return

      setTimeout(() => (this.dialog = false), 15000)
    }
  }
}
</script>
